import produce from "immer";
import { CustomizationState } from "../";
import { checkAndReplaceInvalidPageDefinitions } from "../../../utils/customization/pageDefinition";

export interface ChangeBookTitleAction {
  type: "changeBookTitle";
  bookTitle: string;
}

export function changeBookTitle(
  state: CustomizationState,
  action: ChangeBookTitleAction
): CustomizationState {
  return produce(state, (draftState) => {
    if (draftState.content.templateType !== "book") {
      return;
    }

    if (action.bookTitle) {
      draftState.content.bookTitle = action.bookTitle;
    } else if (draftState.content.bookTitle) {
      delete draftState.content.bookTitle;
    }

    checkAndReplaceInvalidPageDefinitions(draftState);
  });
}
